import { collection, query, where, getDocs, doc, updateDoc, increment } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Increment product view count by 1
 * @param {string} uid - Unique product UID
 */
const UpdateView = async (uid) => {
  try {
    if (!uid) return;

    const q = query(
      collection(db, "products"),
      where("uid", "==", uid)
    );

    const querySnap = await getDocs(q);

    if (!querySnap.empty) {
      querySnap.forEach(async (productDoc) => {
        const productRef = doc(db, "products", productDoc.id);

        await updateDoc(productRef, {
          views: increment(1), // add +1 view
        });
      });
    }
  } catch (error) {
    console.error("Error updating product views:", error);
  }
};

export default UpdateView;
